export default "__VITE_PUBLIC_ASSET__5368f890__"